import { useQuery } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";

interface SasResponse {
	ContainerUrl: string;
	SasQueryString: string;
	SasExpiry: string;
}

export function useProfileImageSas() {
	const { callApi, isAuthenticated } = usePymbleApi();

	return useQuery<SasResponse>({
		queryKey: ["profileImageSas"],
		queryFn: () =>
			callApi("GET", "storage/sas/", {
				params: { container: "profile-images", expiry: 1440 },
			}),
		enabled: isAuthenticated,
		staleTime: 20 * 60 * 1000,
		gcTime: 25 * 60 * 1000,
	});
}

export function useFileSas(container: string) {
	const { callApi, isAuthenticated } = usePymbleApi();

	return useQuery<SasResponse>({
		queryKey: ["fileSas", container],
		queryFn: () =>
			callApi("GET", "storage/sas/", {
				params: { container, expiry: 60 },
			}),
		enabled: isAuthenticated && !!container,
		staleTime: 50 * 60 * 1000,
		gcTime: 55 * 60 * 1000,
	});
}

export function buildFileUrl(url: string, sas: SasResponse | undefined): string {
	if (!sas?.SasQueryString) return url;
	if (sas.ContainerUrl && !url.startsWith("http")) {
		return `${sas.ContainerUrl}/${url}?${sas.SasQueryString}`;
	}
	return `${url}?${sas.SasQueryString}`;
}

export function buildProfileImageUrl(
	contactId: string,
	sas: SasResponse | undefined
): string {
	if (!contactId || !sas?.ContainerUrl || !sas?.SasQueryString) return "";
	return `${sas.ContainerUrl}/${contactId}.jpg?${sas.SasQueryString}`;
}
